import { gql, useLazyQuery, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

const VIWER = gql`
  query Viewer {
    viewer {
      isAdmin
    }
  }
`;

const TALENTECH_AUTH = gql`
  query TALENTECH_AUTH($clientId: String, $scope: String) {
    TalentechAuthorization(clientId: $clientId, scope: $scope) {
      authorizationCode
    }
  }
`;

const Talentech = () => {
  const { t } = useTranslation();
  const { data } = useQuery(VIWER);
  const [getAuthCode] = useLazyQuery(TALENTECH_AUTH);
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('redirect_uri');
  const state = searchParams.get('state');

  useEffect(() => {
    const getAuth = () => {
      getAuthCode().then((res) => {
        if (returnTo && state && res.data?.TalentechAuthorization !== null) {
          const redirectUrl = `${returnTo}?state=${state}&code=${res.data.TalentechAuthorization.authorizationCode}`;
          window.location.href = redirectUrl;
        }
      });
    };

    if (data?.viewer.isAdmin === true) {
      getAuth();
    }
  }, [data, getAuthCode]);

  if (data?.viewer.isAdmin === true) {
    return <div>{t('talentech.redirecting')}</div>;
  } else if (data?.viewer.isAdmin === false) {
    return <div>{t('talentech.mustBeAdmin')}</div>;
  } else {
    return <div>{t('talentech.authorizing')}</div>;
  }
};

export default Talentech;
